import React, { useEffect, useRef, useState, Suspense, lazy } from "react";
import Container from "react-bootstrap/Container";
import { EVENT_TEMPLATES_CDN_URL } from "../../Utils";
import SpinnerLoader from "../../Utils/SpinnerLoader";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import MediaQuery from "react-responsive";
import "./index.css";
import QRCodeGenerate from "./QRCodeGenerate/index.js";

const Banner = lazy(() => import("../Banner/index"));
const PresentQRCode = lazy(() => import("./PresentQRCode"));
const SecurityQRCode = lazy(() => import("./QRCodeSecurity/index.js"));
const Congratulations = lazy(() => import("./Congratulations"));
const Participant = lazy(() => import("./Participant"));
const DateTime = lazy(() => import("./DateTime/index"));
const Header = lazy(() => import("../../PostEvent/Header/index"));

const BannerPost = lazy(() => import("../../PostEvent/BannerPost/BannerPost"));
const ThankYouAttendees = lazy(() => import("../../PostEvent/ThankYouAttendees/ThankYouAttendees"));
const Footer = lazy(() => import("../../FooterNew/footerChanges"));
const SponsorSection = lazy(() => import("../SponsorSection/index.js"));
const Speakers = lazy(() => import("../Speakers/Speakers.js"));
const Agendasection = lazy(() => import("../Agendasection/index.js"));

export default function NFT({ themeId, eventType, eventCreatedUnderDomain, eventPageData, isMobile, showOtherComponents, hashKey, guestData, webpageData }) {
    const [bodyBgImgSrc, setBodyBgImgSrc] = useState("");
    const [imageHeight, setImageHeight] = useState("auto");
    const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";
    const absoluteContentRef = useRef(null);
    const mainImageRef = useRef(null);

    const searchParams = new URLSearchParams(window.location.search);
    const tokenId = searchParams.get("tokenid");

    // Adjust Image Height
    useEffect(() => {
        const adjustImageHeight = () => {
            if (absoluteContentRef.current && mainImageRef.current) {
                const absoluteContentHeight = absoluteContentRef.current.offsetHeight;
                setImageHeight(absoluteContentHeight + (isMobile ? 200 : 300));
            }
        };

        adjustImageHeight();
        window.addEventListener("resize", adjustImageHeight);

        return () => {
            window.removeEventListener("resize", adjustImageHeight);
        };
    }, [isMobile]);

    // Set Banner Sources
    useEffect(() => {
        const bodyBgType = isMobile ? "mobile" : "desktop";
        setBodyBgImgSrc(`${EVENT_TEMPLATES_CDN_URL}assests/angelai-custom-event/theme${themeId}/${bodyBgType}-body.webp`);
    }, [themeId, isMobile]);

    return (
        <div className="nft-main">
            <Suspense fallback={<SpinnerLoader />}>
                <Header
                    eventCreatedUnderDomain={eventCreatedUnderDomain}
                    customAngelAiEvent={true}
                    isMobile={isMobile}
                />
            </Suspense>
            <div className="nft-ussaic-bg">
                <div className="position-relative">
                    {/* <Container className="nftHeadingContainer">
                        <Row className="nft-banner-content">
                            <Col md={12} lg={12} className="nft-banner-text-container">
                                
                                <Image src={imgCDNURL + "ussaicbanner.webp"} className="bannerlogoimagefornft" loading="lazy" alt="US Strategy Logo" />
                            </Col>
                        </Row>
                    </Container> */}

<Suspense fallback={<SpinnerLoader />}>
                                <BannerPost
                                    themeId={themeId}
                                    guestData={guestData}
                                    isMobile={isMobile}
                                />
                            </Suspense>

                    <Suspense fallback={<SpinnerLoader />}>
                        <Container>
                            {/* <Congratulations guestData={guestData} /> */}
                            <Suspense fallback={<SpinnerLoader />}>
                                {/* <Participant
                                    themeId={themeId}
                                    guestData={guestData}
                                    isMobile={isMobile}
                                /> */}
                            </Suspense>

                            
                            {/* <Congratulations guestData={guestData} /> */}
                            
                        </Container>
                        

                        
                        
                    </Suspense>
                </div>
            </div>
            <Suspense fallback={<SpinnerLoader />}>
                                <ThankYouAttendees
                                    themeId={themeId}
                                    guestData={guestData}
                                    isMobile={isMobile}
                                />
                            </Suspense>
            
            <Suspense fallback={<SpinnerLoader />}>
                <Footer
                    themeId={themeId}
                    webpageData={webpageData}
                />



            </Suspense>
        </div>
    );
}
